<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('financial records')"
      :columns="columns"
      :column_search="true"
      resource_url="/financial-record/record/datatables"
    >
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon"><i class="fa fa-plus"></i></span>
          <span>{{ $t("add") }}</span>
        </button>
      </template>
    </generic-table>
  </div>

  <record-modal
    ref="record_modal"
    @success="refresh"
    :module_settings="module_settings"
  />
  <log-modal ref="log_modal" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  download,
  success_message,
  error_message,
  format_currency,
} from "@/utils";
import RecordModal from "./record_modal/Index.vue";
import LogModal from "./log_modal/Index.vue";
import moment from "moment";

export default {
  name: "FinancialRecordDatatable",
  components: { GenericTable, RecordModal, LogModal },
  props: {
    module_settings: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("financial record"),
          searchable: false,
          data: (row) => {
            return row.name || "";
          },
        },
        {
          title: v.$t("financial record number"),
          searchable: false,
          data: (row) => {
            return row.settings?.record_number || "";
          },
        },
        {
          title: v.$t("report generation result"),
          searchable: false,
          data: (row) => {
            if (row.report_result) {
              if (row.report_result.result == "ok")
                return `<span class="icon has-text-success"><i class="fa fa-check"></i></span><span>${v.$t(
                  "report generated"
                )}</span>`;
              else
                return `<span class="icon has-text-danger"><i class="fa fa-times"></i></span><span>${v.$t(
                  "error generating report"
                )}</span>`;
            } else return "";
          },
        },
        // {
        //   title: v.$t("data"),
        //   name: "data",
        //   searchable: false,
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return row.name || "";
        //   },
        // },
        {
          title: v.$t("options"),
          width: "20%",
          searchable: false,
          data: (row) => {
            let btns = [
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("log"),
                icon: "fa fa-list",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.log_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete financial record?"),
                    v,
                    () => {
                      del("/financial-record/record", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("start"),
                icon: "fa fa-bolt",
                icon_class: "is-small has-text-info",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  post("/financial-record/record/start", { uuid: uuid })
                    .then((r) => {
                      v.refresh();
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              },
            ];

            if (row.report_result && row.report_result.file_location) {
              btns.push({
                args: { uuid: row.uuid },
                tooltip: v.$t("download report"),
                icon: "fa fa-download",
                icon_class: "is-small",
                click: function (e) {
                  download(
                    `/financial-record/record/download?uuid=${e.detail.uuid}`,
                    `${row.name} ${moment().format("YYYYMMDDHHmmss")}.pdf`
                  )
                    .then(() => {
                      success_message(v.$t("download complete"));
                    })
                    .catch((error) => {
                      error_message(error);
                    });
                },
              });
            }

            return generate_datatables_buttons(btns);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.record_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
